"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnselectButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const index_1 = require("../KeepTheRhythm/index");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const UnselectButton = ({ groupValue, filterValue, groupTitle, filterTitle, unselectable, isHidden, onFilterRemoved, }) => {
    (0, app_1.useConstructor)(() => {
        index_1.KTR.SetPendingUpdate();
    });
    const handleClick = React.useCallback(() => {
        onFilterRemoved(groupValue, filterValue);
    }, [filterValue, groupValue, onFilterRemoved]);
    return ((0, jsx_runtime_1.jsx)("div", { className: `filters__button filter-unselect-button ${isHidden ? 'filter-unselect-button--hidden' : ''}`, children: (0, jsx_runtime_1.jsxs)("button", { className: `btn-primary text-left bg-df-gray-light-footer hover:bg-df-dark-grayish border-none text-white ${unselectable ? '' : 'non-clickable pointer-events-none'}`, onClick: unselectable ? handleClick : null, children: [groupTitle, ": ", filterTitle, unselectable ? (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "close", className: "text-[18px] ml-2xs" }) : null] }) }));
};
exports.UnselectButton = UnselectButton;
